import { formatMoney } from 'common/src/other/currencyFormat';
import React, { useState, useEffect, useRef } from 'react';
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Modal,
  Box,
  Button as MuiButton,
} from '@mui/material';
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import UsersCombo from '../components/UsersCombo';
import { api } from 'common';
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { BookingModalBody, validateBookingObj } from 'common/sharedFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import { calcEst, showEst, optionsRequired} from '../common/sharedFunctions';
import CircularProgress from '@mui/material/CircularProgress';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import {MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY} from "../common/sharedFunctions"
import { getLangKey } from 'common/src/other/getLangKey';
import {
  C2_FONT,
  c2ModalBoxSx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
  c2SuccessBtnSx,
  c2TextFieldSx,
} from '../components/conecta2ModalStyles';

const selectSx = {
  borderRadius: '12px',
  fontFamily: C2_FONT,
  backgroundColor: '#FBFAFE',
  color: '#1A0F3B',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D7CFEB' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#B8A9E0' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6411ED', borderWidth: 2 },
  '& .MuiSelect-select': { fontFamily: C2_FONT },
};

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
    fontFamily:FONT_FAMILY
  },
  typography:{
    fontFamily:FONT_FAMILY,
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width:480,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.BLACK}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
    marginTop: theme.spacing(1),
    backgroundColor: 'transparent',
    alignContent: 'center',
    borderRadius: "16px",
    width: '100%',
    maxWidth: 720,
  },
  container1: {
    backgroundColor: '#FBFAFE',
    borderRadius: "16px",
    border: '1px solid #D7CFEB',
    padding: '24px',
    width: '100%',
    boxShadow: '0 8px 24px rgba(26,15,59,0.06)',
  },
  title: {
    color: '#1A0F3B',
    padding: '0 0 12px 0',
    backgroundColor: 'transparent',
    fontFamily: C2_FONT,
    borderRadius: 0,
    fontSize: '1.15rem',
    fontWeight: 800,
  },
  gridcontainer: {
    alignContent: 'center'
  },
  items: {
    margin: 0,
    width: '100%'
  },
  input: {
    fontSize: 16,
    color: '#1A0F3B',
    fontFamily: C2_FONT,
  },
  inputdimmed: {
    fontSize: 16,
    color: '#766293',
    fontFamily: C2_FONT,
  },
  carphoto: {
    height: '18px',
    marginRight: '10px'
  },
  carphotoRtl:{
    height: '16px',
    marginLeft:'10px'
  },
  buttonStyle: {
    margin: 0,
    width: '100%',
    height: 48,
    borderRadius: "12px",
    background: 'linear-gradient(90deg, #6411ED 0%, #7628FF 100%)',
    color: '#FBFAFE',
    fontFamily: C2_FONT,
    fontWeight: 700,
    textTransform: 'none',
    boxShadow: '0 6px 16px rgba(100,17,237,0.28)',
  },
  buttonStyle1:{
    backgroundColor: MAIN_COLOR,
    fontFamily: C2_FONT
  },
  buttonStyle2:{
    backgroundColor: SECONDORY_COLOR,
    fontFamily: C2_FONT
  },
  inputRtl: {
    "& label": {
      right: 25,
      left: "auto",
      fontFamily: C2_FONT,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 18,
      fontFamily: C2_FONT,
    },
    "& label.Mui-focused": {
      color: '#6411ED',
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: '#6411ED',
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: '#6411ED',
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: '#6411ED',
      },
    },
    "& input": {
      fontFamily: C2_FONT,
    },
  },
  rightRty:{
    "& legend": {
      marginRight: 30,
      fontFamily: C2_FONT,
    },
    "& input": {
      fontFamily: C2_FONT,
    },
  },
  textField: {
    "& label.Mui-focused": {
      color: '#6411ED',
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: '#6411ED',
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: '#6411ED',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: '12px',
      "&.Mui-focused fieldset": {
        borderColor: '#6411ED',
      },
    },
    "& input": {
      fontFamily: C2_FONT,
    },
  },
}));

const icons = {
  'mercadopago':require('../assets/payment-icons/mercadopago-logo.png').default,
  'openpay':require('../assets/payment-icons/credicard.png').default,
  'pse':require('../assets/payment-icons/pse.png').default,
  'epayco':require('../assets/payment-icons/epayco-logo.jpg').default
}

export default function AddBookings(props) {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    GetDistance,
    updateBooking,
    updateProfileWithEmail,
    checkUserExists,
    fetchDrivers,
    roundTripPayable,
    roundTripMinimum,
    isRoundTrip,
    applyRoundTripToEstimate,
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const cartypes = useSelector(state => state.cartypes.cars);
  const estimatedata = useSelector(state => state.estimatedata);
  const bookingdata = useSelector(state => state.bookingdata);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const providers = useSelector(state => state.paymentmethods.providers);
  const activeBookings = useSelector(state => state.bookinglistdata.active);
  const [carType, setCarType] = useState(t('select_car'));
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [estimateModalStatus, setEstimateModalStatus] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [userCombo, setUserCombo] = useState(null);
  const [estimateRequested, setEstimateRequested] = useState(false);
  const [bookingType, setBookingType] = useState('Book Now');
  const rootRef = useRef(null);
  const [tempRoute, setTempRoute] = useState();
  const [drivers,setDrivers] = useState([]);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const {state} = useLocation();
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [roundTrip, setRoundTrip] = useState(0);
  const [tripInstructions, setTripInstructions] = useState('');
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [bookingOnWait,setBookingOnWait] = useState();
  const [deliveryWithBid, setDeliveryWithBid] = useState(0);
  const [otherPerson, setOtherPerson] = useState(false);
  const [offerFare, setOfferFare] = useState('');
  const [minimumPrice, setMinimumPrice] = useState(0);

  useEffect(() => {
    if (settings && settings.bookingFlow) {
        setDeliveryWithBid(settings.bookingFlow === "2" ? 1 : 0)
    }
  }, [settings, settings.bookingFlow])



  const [instructionData,setInstructionData] = useState({
    otherPerson : "",
    otherPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    parcelTypeIndex: 0,
    optionIndex: 0,
    parcelTypeSelected: null,
    optionSelected: null
  });

  const [profileData,setProfileData] = useState({
    firstName : '',
    lastName : '',
    email: ''
  });

  const [payment_mode, setPaymentMode] = useState(0);
  const [radioProps,setRadioProps] =  useState([]);

  const navigate = useNavigate();

  useEffect(()=>{
      if(settings && providers){
        setSelectedProvider(providers[0]);

       // let arr = [];
        let val = 0;
        let arr = [{ label: t('cash'), value: val, cat: 'cash' }];
        
       /* if(!settings.disable_online && providers && providers.length > 0){ 
       if(!settings.disable_online){ 
            val++;
            arr.push({ label: t('card'), value: val , cat: 'card' });
        } 
        if(!settings.disable_cash){
            val++;
            arr.push({ label: t('cash'), value: val, cat: 'cash' });
        }
        if(!settings.disable_neki){
            val++;
            arr.push({ label: t('Necki'), value: val, cat: 'neki' });
        }
        if(!settings.disable_bank){
            val++;
            arr.push({ label: t('Bancolombia'), value: val, cat: 'bank' });
        }
            */
        setRadioProps(arr);
      }
  },[settings, providers, t]);;

  useEffect(() => {
    if(state && state !== null){
      let carDetails = state.carData;
      setCarType(carDetails.name)
      setInstructionData({
        deliveryPerson : "",
        deliveryPersonPhone: "",
        pickUpInstructions: "",
        deliveryInstructions: "",
        parcelTypeIndex: 0,
        optionIndex: 0,
        parcelTypeSelected: Array.isArray(carDetails.parcelTypes) ? carDetails.parcelTypes[0] : null,
        optionSelected: Array.isArray(carDetails.options) ? carDetails.options[0] : null
      })
      setSelectedCarDetails(carDetails);
    }
  }, [state]);

  const handleChange = (e) => {
    if(e.target.name === 'parcelTypeIndex'){
      setInstructionData({ 
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails.parcelTypes[e.target.value]
      });
    }else if(e.target.name === 'optionIndex'){
      setInstructionData({ 
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails.options[e.target.value]
      });
    }else if(e.target.name === 'payment_mode'){
      setPaymentMode(e.target.value);
    }else if(e.target.name === 'selectedProviderIndex'){
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    }else if(e.target.name === 'tripInstructions'){
      setTripInstructions(e.target.value);
    }else if(e.target.name === 'roundTrip'){
      setRoundTrip(e.target.value);
    }else if(e.target.name === 'bookingFlow'){
      setDeliveryWithBid(e.target.value);
    }else if(e.target.name === 'firstName'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'lastName'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'email'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'offerFare'){
      setOfferFare(e.target.value);
    }else{
      setInstructionData({ ...instructionData, [e.target.name]: e.target.value });
    }
  };

  const [selectedDate, setSelectedDate] = useState(GetDateString());

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    setSelectedCarDetails(null);
    setCarType(t('select_car'));
    setBookingType('Book Now');
    setEstimateRequested(false);
  }

  useEffect(() => {
    if (auth.profile && bookingOnWait) {
      setEstimateModalStatus(false); 
      dispatch(addBooking(bookingOnWait));
      setBookingOnWait(null);
      setLoading(false);
    }
  }, [auth.profile,bookingOnWait,dispatch,addBooking])

  useEffect(() => {
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'PAYMENT_PENDING') {
      if(bookingdata.booking.mainData.payment_mode === 'cash'){
        dispatch(clearBooking());
        setTempRoute(null);
        setLoading2(false);
        navigate('/bookings')
      } else{
        if(bookingdata.booking.mainData.payment_mode === 'card'){
          setLoading2(false);
          setPaymentModalStatus(true);
        }else{
          setLoading2(false);
          setWalletModalStatus(true);
        }
      }
    }
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'NEW') {
      dispatch(clearBooking());
      setTempRoute(null);
      setLoading2(false);
      navigate('/bookings')
    }
  }, [bookingdata.booking,clearBooking,dispatch,navigate]);

  const handleCarSelect = (event) => {
    setCarType(event.target.value);
    let carDetails = null;
    const visibleCartypes = cartypes ? cartypes.filter(c => c.visibleInApp !== false) : [];
    for (let i = 0; i < visibleCartypes.length; i++) {
      if (visibleCartypes[i].name === event.target.value) {
        carDetails = visibleCartypes[i];
        let instObj = {...instructionData};
        if(Array.isArray(visibleCartypes[i].parcelTypes) && instObj.parcelTypeSelected !== visibleCartypes[i].parcelTypes[0]){
          instObj.parcelTypeSelected = visibleCartypes[i].parcelTypes[0];
          instObj.parcelTypeIndex = 0;
        }
        if(Array.isArray(visibleCartypes[i].options) && instObj.optionSelected !== visibleCartypes[i].options[0]){
          instObj.optionSelected = visibleCartypes[i].options[0];
          instObj.optionIndex = 0;
        }
        setInstructionData(instObj);
      }
    }
    setSelectedCarDetails(carDetails);
  };

  const handleBookTypeSelect = (event) => {
    setBookingType(event.target.value);
    if (bookingType === 'Book Later') {
      setSelectedDate(GetDateString());
    }
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (estimatedata.estimate && estimateRequested) {
      setEstimateRequested(false);
      setEstimateModalStatus(true);
    }
    if (estimatedata.estimate && estimateRequested && settings && !settings.coustomerBidPrice) {
      const est = estimatedata.estimate;
      const anchorSmart =
        settings.smartFareBidGuard !== false ||
        !(Number(est.smartFareMultiplier) > 1);
      const price = anchorSmart
        ? est.estimateFare
        : (est.estimateFareBeforeSmart != null ? est.estimateFareBeforeSmart : est.estimateFare);
      let ammount =  settings.coustomerBidPriceType === 'flat' ? parseFloat(price- settings.bidprice).toFixed(settings.decimal) : parseFloat(price - parseFloat(price*(settings.bidprice/100))).toFixed(settings.decimal);
      if(ammount && ammount > 0){setMinimumPrice(ammount)}
    }
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'customer' && ((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin')) {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : t("hidden_demo")) + ') ' + (settings.AllowCriticalEditsAdmin? user.email : t("hidden_demo")),
            'pushToken': user.pushToken ? user.pushToken : ''
          });
        }
      }
      setUsers(arr);
      let arrDrivers = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if ((user.usertype) && (user.usertype === 'driver') && (user.approved === true) && (user.queue === false) && (user.driverActiveStatus === true) && (user.location) && ((user.licenseImage && settings.license_image_required) || !settings.license_image_required) && ((user.carApproved && settings.carType_required) || !settings.carType_required) && ((user.term && settings.term_required) || !settings.term_required)) {
          if((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin' || auth.profile.usertype === 'customer'){
            arrDrivers.push({
              'uid': user.id,
              'location': user.location,
              'carType': user.carType,
              'fleetadmin': user.fleetadmin ? user.fleetadmin : null
            });
          }
        }
      }
      setDrivers(arrDrivers);
    }
  }, [estimatedata.estimate, userdata.users, estimateRequested, settings, auth.profile.usertype, auth.profile.uid,t]);

  const isCustomer = auth.profile.usertype === 'customer';

  useEffect(() => {
    if (isCustomer) {
      dispatch(fetchDrivers('web', true));
    }
  }, [isCustomer, dispatch, fetchDrivers]);

  useEffect(() => {
    if (isCustomer) {
      setDrivers((userdata.drivers || [])
        .filter((driver) => driver.queue === false)
        .map((driver) => ({
          'uid': driver.uid,
          'location': driver.location,
          'carType': driver.carType,
          'fleetadmin': driver.fleetadmin ? driver.fleetadmin : null
        })));
    }
  }, [isCustomer, userdata.drivers]);
 
 
  useEffect(() => {
    if(auth.profile.usertype && auth.profile.usertype==='customer'){
      setUserCombo({
        'firstName': auth.profile.firstName,
        'lastName': auth.profile.lastName,
        'mobile': auth.profile.mobile,
        'email': auth.profile.email,
        'uid': auth.profile.uid,
        'pushToken': auth.profile.pushToken ? auth.profile.pushToken : ''
      })
    }
  }, [auth.profile]);


  const mobile = (userCombo && userCombo.mobile ? true : false);

  const handleGetOptions = (e) => {
    e.preventDefault();
    // Pasajeros: cédula opcional (no bloquea reserva). Admin/fleetadmin siempre OK.
    if (auth.profile.usertype === 'customer' || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
      if(!(settings && settings.disable_cash && (auth.profile.usertype==='admin'|| auth.profile.usertype === 'fleetadmin')) || auth.profile.usertype==='customer'){
        if((auth.profile.usertype==='customer' && parseFloat(auth.profile.walletBalance)>=0) || auth.profile.usertype==='admin' || auth.profile.usertype === 'fleetadmin'){
          setEstimateRequested(true);
          if (userCombo && pickupAddress && dropAddress && selectedCarDetails) {
            const directionService = new window.google.maps.DirectionsService();
            directionService.route(
              {
                origin: new window.google.maps.LatLng(pickupAddress.coords.lat, pickupAddress.coords.lng),
                destination: new window.google.maps.LatLng(dropAddress.coords.lat, dropAddress.coords.lng),
                travelMode: window.google.maps.TravelMode.DRIVING
              },
              (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                  const legs = result.routes[0].legs || [];
                  const route = {
                    distance_in_km: legs.reduce((m, leg) => m + ((leg.distance && leg.distance.value) || 0), 0) / 1000,
                    time_in_secs: legs.reduce((s, leg) => s + ((leg.duration && leg.duration.value) || 0), 0),
                    polylinePoints:result.routes[0].overview_polyline
                  };
                  setTempRoute(route);
                  if(pickupAddress && dropAddress){
                    if (bookingType === 'Book Now') {
                      if(mobile === true){
                        if(Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)){
                          setOptionModalStatus(true);
                        }else{
                          let estimateRequest = {
                            pickup: pickupAddress,
                            drop: dropAddress,
                            carDetails: selectedCarDetails,
                            instructionData: instructionData,
                            routeDetails: route
                          };
                          dispatch(getEstimate(estimateRequest));
                        }
                      }else{
                        setCommonAlert({ open: true, msg: t('incomplete_user')});
                      }
                    } else {
                        if (bookingType === 'Book Later' && selectedDate) {
                          if (MinutesPassed(selectedDate) >= 15) {
                            if(mobile === true){
                              if(Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)){
                                setOptionModalStatus(true);
                              }else{
                                let estimateRequest = {
                                  pickup: pickupAddress,
                                  drop: dropAddress,
                                  carDetails: selectedCarDetails,
                                  instructionData: instructionData,
                                  routeDetails: route
                                };
                                dispatch(getEstimate(estimateRequest));
                              }
                            }else{
                              setCommonAlert({ open: true, msg: t('incomplete_user')});
                            }
                          } else {
                            setCommonAlert({ open: true, msg: t('past_booking_error') });
                          }
                        } else {
                          setCommonAlert({ open: true, msg: t('select_proper') });
                        }
                      }
                  } else {
                    setCommonAlert({ open: true, msg: t('place_to_coords_error') })
                  }
                }
              }
            )
          } else {
            setCommonAlert({ open: true, msg: t('select_proper') })
          }
        }else{
          setCommonAlert({ open: true, msg: t('wallet_balance_low') })
        }
      } else {
        setCommonAlert({ open: true, msg: t('cash_booking_false') })
      }
    } else {
      setCommonAlert({ open: true, msg: t('verifyid_error') })
    }    
  }

  const handleWalletPayment = (e) => {
    e.preventDefault();
    let curBooking = { ...bookingdata.booking.mainData };
    if(parseFloat(curBooking.trip_cost)>parseFloat(auth.profile.walletBalance) && radioProps[payment_mode].cat === 'wallet'){
      setCommonAlert({open:true, msg: t('wallet_balance_low')});
    }else{
      let requestedDrivers = {};
      if (settings.autoDispatch && bookingType === 'Book Now') {
        for (let i = 0; i < drivers.length; i++) {
          const driver = drivers[i];
          let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
          if (settings.convert_to_mile) {
            distance = distance / 1.609344;
          }
          if (distance < ((settings && settings.driverRadius) ? settings.driverRadius : 10) && selectedCarDetails.name === driver.carType) {
            requestedDrivers[driver['uid']] = true;
          }
        }
      }
      curBooking.prepaid = true;
      curBooking.status = 'NEW';
      curBooking.payment_mode = "wallet";
      curBooking.customer_paid = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.requestedDrivers = requestedDrivers;

      dispatch(updateBooking(curBooking));

      setTimeout(()=>{
        dispatch(clearEstimate());
        setPaymentModalStatus(false);
        setWalletModalStatus(false);
        clearForm();
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings')
      },1500);
    }
  }

  const handleGetEstimate = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
    let estimateRequest = {
      pickup: pickupAddress,
      drop: dropAddress,
      carDetails: selectedCarDetails,
      instructionData: instructionData,
      routeDetails: tempRoute
    };
    dispatch(getEstimate(estimateRequest));
    if (isCustomer) {
      dispatch(fetchDrivers('web', true));
    }
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    setLoading2(true);
    let requestedDrivers = {};
    let driverEstimates = {};

    let notfound = true;
    if(activeBookings){
        for(let i=0; i<activeBookings.length; i++){
            if(activeBookings[i].payment_mode==='wallet' && activeBookings[i].status!=='PAID'){
                notfound = false;
                break;
            }
        }
    }

    if((radioProps[payment_mode].cat === 'wallet' && notfound && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin'){
      const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
      if ((otherPerson && /\S/.test(instructionData.otherPerson) && regx1.test(instructionData.otherPersonPhone) && instructionData.otherPersonPhone && instructionData.otherPersonPhone.length > 6) || !otherPerson){
        const wantRoundTrip = isRoundTrip ? isRoundTrip(roundTrip) : (roundTrip === 1 || roundTrip === true);
        const effectiveMin = roundTripMinimum
          ? roundTripMinimum(minimumPrice, wantRoundTrip)
          : (wantRoundTrip ? parseFloat(minimumPrice) * 2 : parseFloat(minimumPrice));
        const payableAmount = roundTripPayable
          ? roundTripPayable({
              offerFare,
              estimateFare: estimatedata.estimate?.estimateFare,
              roundTrip: wantRoundTrip,
            })
          : (parseFloat(offerFare) > 0
              ? parseFloat(offerFare)
              : (wantRoundTrip ? parseFloat(estimatedata.estimate.estimateFare) * 2 : parseFloat(estimatedata.estimate.estimateFare)));
        if((offerFare > 0 && offerFare >= parseFloat(effectiveMin)) || offerFare === ''){
          if ((radioProps[payment_mode].cat === 'wallet' && (parseFloat(auth.profile.walletBalance) >= parseFloat(payableAmount)) && !calcEst && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || (radioProps[payment_mode].cat === 'wallet' && calcEst && auth.profile.usertype === 'customer')|| auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
            if (settings.autoDispatch && bookingType === 'Book Now') {
              for (let i = 0; i < drivers.length; i++) {
                const driver = drivers[i];
                let distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
                if (settings.convert_to_mile) {
                  distance = distance / 1.609344;
                }
                if (distance < ((settings && settings.driverRadius) ? settings.driverRadius : 10) && ((settings.carType_required && selectedCarDetails.name === driver.carType) || !settings.carType_required) && ((auth.profile.usertype === 'fleetadmin' && driver.fleetadmin === auth.profile.uid) || auth.profile.usertype !== 'fleetadmin')) {
                  requestedDrivers[driver['uid']] = true;
                  driverEstimates[driver['uid']] = {distance: distance, timein_text: ((distance * 2) + 1).toFixed(0) + ' min'};
                }
              }
              if(Object.keys(requestedDrivers).length=== 0){
                setLoading2(false);
                setCommonAlert({open:true, msg: t('no_driver_found_alert_messege')});
                return;
              }
            }

            let bookingObject = {
              pickup: pickupAddress,
              drop: dropAddress,
              carDetails: selectedCarDetails,
              userDetails: {
                uid: userCombo.uid,
                firstName: userCombo.firstName,
                lastName: userCombo.lastName,
                mobile: userCombo.mobile,
                pushToken: userCombo.pushToken,
                email: userCombo.email
              },
              estimate: applyRoundTripToEstimate
                ? applyRoundTripToEstimate(estimatedata.estimate, wantRoundTrip)
                : estimatedata.estimate,
              instructionData: instructionData,
              tripInstructions: tripInstructions,
              roundTrip: wantRoundTrip,
              tripdate: bookingType === 'Book Later' ? new Date(selectedDate).getTime() : new Date().getTime(),
              bookLater: bookingType === 'Book Later' ? true : false,
              settings: settings,
              booking_type_admin: auth.profile.usertype === 'admin'? true: false,
              booking_type_fleetadmin: auth.profile.usertype === 'fleetadmin'? true: false,
              fleetadmin: auth.profile.usertype === 'fleetadmin'? auth.profile.uid: null,
              requestedDrivers: calcEst ? requestedDrivers : (optionsRequired && radioProps[payment_mode].cat === 'cash') ? requestedDrivers : (settings.prepaid && radioProps[payment_mode].cat === 'cash') ? requestedDrivers : !settings.prepaid ? requestedDrivers : requestedDrivers ,
              driverEstimates: driverEstimates,
              payment_mode: (auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin' )?'cash':radioProps[payment_mode].cat,
              booking_from_web: true,
              deliveryWithBid : auth.profile.usertype === 'customer'?  deliveryWithBid === 0 ? false : true :false,
              offerFare: (offerFare && offerFare > 0) ? offerFare : 0,
              customer_offer: (offerFare && offerFare > 0) ? offerFare : 0,
              customer_min_offer: parseFloat(effectiveMin) > 0 ? parseFloat(effectiveMin) : null,
            };

            if(auth.profile.usertype === 'customer' && !(auth.profile.firstName && auth.profile.lastName && auth.profile.email && auth.profile.firstName.length>0 && auth.profile.lastName.length>0 && auth.profile.email.length>0)){
              // const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
              // if ((optionsRequired && /\S/.test(instructionData.deliveryPerson) && regx1.test(instructionData.deliveryPersonPhone) && instructionData.deliveryPersonPhone && instructionData.deliveryPersonPhone.length > 6) || !optionsRequired){
                if((profileData.firstName && profileData.firstName.length > 0 && profileData.lastName && profileData.lastName.length > 0) || (auth.profile.firstName && auth.profile.firstName.length > 0 && auth.profile.lastName && auth.profile.lastName.length > 0)){
                  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  if((re.test(profileData.email) && !auth.profile.email) || (auth.profile.email && auth.profile.email.length > 0)){
                    setLoading(true);
                    checkUserExists({email: profileData.email}).then(async(res) => {
                      if (res.users && res.users.length > 0) {
                        setLoading(false);
                        alert(t('user_exists'));
                      }
                      else if(res.error){
                        setLoading(false);
                        alert(t('email_or_mobile_issue'));
                      } else{
                        setLoading(false);
                        if(radioProps[payment_mode].cat === 'card'){
                          const paymentPacket = { 
                            payment_mode: 'card',
                            customer_paid: parseFloat(payableAmount).toFixed(settings.decimal),
                            cardPaymentAmount: parseFloat(payableAmount).toFixed(settings.decimal),
                            discount: 0,
                            usedWalletMoney:0,
                            cashPaymentAmount: 0,
                            promo_applied: false,
                            promo_details: null,
                            payableAmount: parseFloat(payableAmount).toFixed(settings.decimal),
                          };
                          bookingObject['paymentPacket'] = paymentPacket;
                        }
                
                        const result = validateBookingObj(t, bookingObject, instructionData, otherPerson);
                        if(result.error){
                          setLoading2(false);
                          setCommonAlert({ open: true, msg: result.msg });
                        } else{
                          profileData['uid'] = auth.profile.uid;
                          let bookingData = result.bookingObject;
                          bookingData.userDetails.firstName = profileData.firstName;
                          bookingData.userDetails.lastName = profileData.lastName;
                          bookingData.userDetails.email = profileData.email;
                          setBookingOnWait(bookingData);
                        }
                        setTimeout(()=>{
                          dispatch(updateProfileWithEmail(profileData));
                        },200) 
                      }
                  });
                  } else {
                    setLoading2(false);
                    setCommonAlert({ open: true, msg: t('proper_email') })
                  }
                } else {
                  setLoading2(false);
                  setCommonAlert({ open: true, msg: t('proper_input_name') })
                }
              // } else {
              //   setCommonAlert({ open: true, msg: t('deliveryDetailMissing') })
              // }
            } else{
              if(radioProps[payment_mode].cat === 'card'){
                const paymentPacket = { 
                  payment_mode: 'card',
                  customer_paid: parseFloat(payableAmount).toFixed(settings.decimal),
                  cardPaymentAmount: parseFloat(payableAmount).toFixed(settings.decimal),
                  discount: 0,
                  usedWalletMoney:0,
                  cashPaymentAmount: 0,
                  promo_applied: false,
                  promo_details: null,
                  payableAmount: parseFloat(payableAmount).toFixed(settings.decimal),
                };
                bookingObject['paymentPacket'] = paymentPacket;
              }
              const result = validateBookingObj(t, bookingObject, instructionData, otherPerson);
              if(result.error){
                setLoading2(false);
                setCommonAlert({ open: true, msg: result.msg });
              } else{
                setEstimateModalStatus(false); 
                dispatch(addBooking(result.bookingObject));
              }
            }
          }else{
            setLoading2(false);
            setCommonAlert({ open: true, msg: t('wallet_balance_low') });
          }
        }else{
          setLoading2(false);
          setCommonAlert({ open: true, msg: t('offer_price_greter_minimum_price') })
        }
      } else {
        setLoading2(false);
        setCommonAlert({ open: true, msg: t('otherPersonDetailMissing') })
      }
    } else {
      setLoading2(false);
      setCommonAlert({ open: true, msg: t('wallet_booking_alert') });
    }
  };

  const handleOptionModalClose = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
  };

  const handleEstimateModalClose = (e) => {
    e.preventDefault();
    setEstimateModalStatus(false);
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleWalletModalClose = (e) => {
    setTimeout(()=>{
      setWalletModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    },1500);
  }

  const handlePaymentModalClose = (e) => {
    setTimeout(()=>{
      setPaymentModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    },1500);
  }
return loading2 ? (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '80vh',
    }}
  >
    <CircularProgress sx={{ color: '#6411ED' }} />
  </Box>
)
:
   (
    <Box className={classes.container} ref={rootRef} sx={{ mx: 'auto' }}>
      <Box className={classes.container1}>
        <Typography
          sx={{
            fontFamily: C2_FONT,
            fontWeight: 800,
            fontSize: '1.15rem',
            color: '#1A0F3B',
            mb: 0.5,
            textAlign: isRTL === 'rtl' ? 'right' : 'left',
          }}
        >
          {t('add_booking_title', { defaultValue: 'Nueva reserva' })}
        </Typography>
        <Typography
          sx={{
            fontFamily: C2_FONT,
            fontSize: '0.9rem',
            color: '#766293',
            mb: 2.5,
            textAlign: isRTL === 'rtl' ? 'right' : 'left',
          }}
        >
          Completa los datos del viaje para continuar.
        </Typography>
          <Grid container spacing={2} >
            <Grid item xs={12} >
              {users && auth.profile.usertype && auth.profile.usertype!=='customer' ?
                <UsersCombo
                  className={classes.items}
                  placeholder={t('select_user')}
                  users={users}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
                : null}
            </Grid>
            <Grid item xs={12} >
              <GoogleMapsAutoComplete
                variant={"outlined"}
                placeholder={t('pickup_location')}
                value={pickupAddress}
                className={classes.items}
                onChange={
                  (value) => {
                    setPickupAddress(value);
                  }
                }
              />
            </Grid>
            <Grid item xs={12} >
              <GoogleMapsAutoComplete placeholder={t('drop_location')}
                variant={"outlined"}
                value={dropAddress}
                className={classes.items}
                onChange={
                  (value) => {
                    setDropAddress(value);
                  }
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} >
              {cartypes && cartypes.filter(c => c.visibleInApp !== false).length > 0 ?
                  <Select
                     labelId="demo-simple-select-label"
                     id="demo-simple-select"
                      value={carType}
                      onChange={handleCarSelect}
                      variant="outlined"
                      fullWidth
                      style={{textAlign:isRTL==='rtl'? 'right':'left',}}
                      className={carType === t('select_car') ? classes.inputdimmed : classes.input}
                      sx={selectSx}
                  >
                    <MenuItem dense={true} value={t('select_car')} key={t('select_car')} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:C2_FONT}}>
                      {t('select_car')}
                    </MenuItem>
                    {
                      cartypes.filter(c => c.visibleInApp !== false).sort((a, b) => a.pos - b.pos).map((car) =>
                        <MenuItem dense={true}  key={car.name} value={car.name} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:C2_FONT}}>
                          <img src={car.image} className={isRTL==='rtl'? classes.carphotoRtl : classes.carphoto} alt="car types"/>{t(getLangKey(car.name))}
                        </MenuItem>
                      )
                    }
                  </Select>
                : null}
            </Grid>
            <Grid item xs={12} sm={6}>
                <Select
                  id="booking-type-native"
                  value={bookingType}
                  onChange={handleBookTypeSelect}
                  className={classes.input}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  sx={selectSx}
                  variant="outlined"
                  fullWidth
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem dense key={"Book Now"} value={"Book Now"} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:C2_FONT}}>
                    {t('book_now')}
                  </MenuItem>
                  <MenuItem dense key={"Book Later"} value={"Book Later"} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:C2_FONT}}>
                    {t('book_later')}
                  </MenuItem>
                </Select>
              </Grid>
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={6} >
                  <TextField
                    id="datetime-local"
                    label={t('booking_date_time')}
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    className={isRTL==='rtl'?classes.inputRtl:null}
                    sx={c2TextFieldSx}
                    InputLabelProps={{ shrink: true, style: { fontFamily: C2_FONT } }}
                    InputProps={{
                      style:{textAlignLast:isRTL==='rtl'?'end':'start', fontFamily: C2_FONT}
                    }}
                    value={selectedDate}
                    onChange={onDateChange}
                  />
                </Grid>
              : null}
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={6} >
                  <MuiButton
                    fullWidth
                    onClick={handleGetOptions}
                    variant="contained"
                    startIcon={<DirectionsCarFilledOutlinedIcon />}
                    sx={{ ...c2PrimaryBtnSx, height: 48, width: '100%' }}
                  >
                    {t('book', { defaultValue: 'Reservar' })}
                  </MuiButton>
                </Grid>
              :
                <Grid item xs={12} >
                  <MuiButton
                    fullWidth
                    onClick={handleGetOptions}
                    variant="contained"
                    startIcon={<DirectionsCarFilledOutlinedIcon />}
                    sx={{ ...c2PrimaryBtnSx, height: 48, width: '100%', mt: 0.5 }}
                  >
                    {t('book', { defaultValue: 'Reservar' })}
                  </MuiButton>
                </Grid>
              }
          </Grid>
      </Box>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={optionModalStatus}
        onClose={handleOptionModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Box sx={{ ...c2ModalBoxSx, direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
          {selectedCarDetails && selectedCarDetails.parcelTypes?
            <FormControl component="fieldset" sx={{ mb: 2, width: '100%' }}>
              <FormLabel component="legend" sx={{ fontFamily: C2_FONT, color: '#766293' }}>{t('parcel_types')}</FormLabel>
              <RadioGroup name="parcelTypeIndex" value={instructionData.parcelTypeIndex} onChange={handleChange}>
                {selectedCarDetails.parcelTypes.map((element,index) =>
                  <FormControlLabel key={element.description} value={index} control={<Radio sx={{ color: '#6411ED', '&.Mui-checked': { color: '#6411ED' } }} />} label={ <Typography sx={{ fontFamily: C2_FONT }}>{ settings.swipe_symbol===false? formatMoney(element.amount, settings) + ' - ' + t(getLangKey(element.description)): formatMoney(element.amount, settings, { isRTL: true }) + ' - ' + t(getLangKey(element.description))}</Typography>}/>
                )}
              </RadioGroup>
            </FormControl>
          :null}
          {selectedCarDetails && selectedCarDetails.options?
            <FormControl component="fieldset" sx={{ mb: 2, width: '100%' }}>
              <FormLabel component="legend" sx={{ fontFamily: C2_FONT, color: '#766293' }}>{t('options')}</FormLabel>
              <RadioGroup name="optionIndex" value={instructionData.optionIndex} onChange={handleChange}>
                {selectedCarDetails.options.map((element,index) =>
                  <FormControlLabel key={element.description} value={index} control={<Radio sx={{ color: '#6411ED', '&.Mui-checked': { color: '#6411ED' } }} />} label={ <Typography sx={{ fontFamily: C2_FONT }}>{ settings.swipe_symbol===false? formatMoney(element.amount, settings) + ' - ' + t(getLangKey(element.description)): formatMoney(element.amount, settings, { isRTL: true }) + ' - ' + t(getLangKey(element.description))}</Typography>} />
                )}
              </RadioGroup>
            </FormControl>
          :null}
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button onClick={handleOptionModalClose} variant="outlined" sx={c2SecondaryBtnSx}>
            {t('cancel')}
          </Button>
          <Button onClick={handleGetEstimate} variant="contained" sx={c2PrimaryBtnSx}>
            {t('get_estimate')}
          </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={estimateModalStatus}
        onClose={handleEstimateModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Box sx={{ ...c2ModalBoxSx, maxWidth: 520, direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
          <BookingModalBody 
              classes={classes}  
              instructionData={instructionData} 
              handleChange={handleChange}
              tripInstructions={tripInstructions}
              roundTrip={roundTrip}
              auth={auth}
              profileData={profileData}
              settings={settings}
              deliveryWithBid={deliveryWithBid}
              otherPerson={otherPerson}
              setOtherPerson={setOtherPerson}
              minimumPrice={minimumPrice}
              offerFare={offerFare}
              estimate={estimatedata.estimate}
          />
          {showEst && settings && settings.hasOwnProperty( "bookingFlow" )&& (settings.bookingFlow === "0" || settings.bookingFlow === "2") ? null :
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: 28, color: '#6411ED', my: 1.5 }}>
              {t('total')} - {formatMoney(
                (isRoundTrip && isRoundTrip(roundTrip)) || roundTrip === 1
                  ? (parseFloat(estimatedata.estimate?.estimateFare) || 0) * 2
                  : (estimatedata.estimate?.estimateFare || 0),
                settings,
                { isRTL: !!settings.swipe_symbol }
              )}
            </Typography>
          }
          {auth.profile.usertype === 'customer'?
            <FormControl component="fieldset" sx={{ mb: 2, width: '100%' }}>
              <FormLabel component="legend" sx={{ fontFamily: C2_FONT, color: '#766293' }}>{t('payment_mode')}</FormLabel>
              <RadioGroup name="payment_mode" value={payment_mode} onChange={handleChange}>
                {radioProps.map((element,index) =>
                  <FormControlLabel key={element.cat} value={index} control={<Radio sx={{ color: '#6411ED', '&.Mui-checked': { color: '#6411ED' } }} />} label={ <Typography sx={{ fontFamily: C2_FONT }}>{element.label}</Typography>} />
                )}
              </RadioGroup>
            </FormControl>
          :null}
          {loading?
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
              <CircularProgress sx={{ color: '#6411ED' }} />
            </Box>
          :
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Button onClick={handleEstimateModalClose} variant="outlined" sx={c2SecondaryBtnSx}>
                {t('cancel')}
              </Button>
              <Button onClick={confirmBooking} variant="contained" sx={c2SuccessBtnSx}>
                {t('book_now')}
              </Button>
            </Box>
          }
        </Box>
      </Modal>

      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={walletModalStatus}
        onClose={handleWalletModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Box sx={c2ModalBoxSx}>
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 800, fontSize: '1.15rem', color: '#1A0F3B', mb: 1.5 }}>
              {t('payment', { defaultValue: 'Pago' })}
            </Typography>
            {bookingdata && bookingdata.booking?
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: 28, color: '#6411ED', mb: 1 }}>
              { formatMoney(bookingdata.booking.mainData.trip_cost || 0, settings, { isRTL: !!settings.swipe_symbol }) }
            </Typography>
            :null}
            <Typography sx={{ fontFamily: C2_FONT, color: '#766293', mb: 2.5 }}>
              {t('use_wallet_balance') + " " + formatMoney(auth.profile.walletBalance || 0, settings, { isRTL: !!settings.swipe_symbol }) + ")"}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button onClick={handleWalletModalClose} variant="outlined" sx={c2SecondaryBtnSx}>
              {t('cancel')}
            </Button>
            <Button variant="contained" sx={c2SuccessBtnSx} onClick={handleWalletPayment}>
              {t('paynow_button')}
            </Button>
            </Box>
        </Box>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Box sx={c2ModalBoxSx}>
          {providers && selectedProvider && bookingdata && bookingdata.booking?
          <form action={selectedProvider.link} method="POST">
            <input type='hidden' name='order_id' value={bookingdata.booking.booking_id}/>
            <input type='hidden' name='amount' value={bookingdata.booking.mainData.trip_cost}/>
            <input type='hidden' name='currency' value={settings.code}/>
            <input type='hidden' name='product_name' value={t('bookingPayment')}/>
            <input type='hidden' name='first_name' value={auth.profile.firstName}/>
            <input type='hidden' name='last_name' value={auth.profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={bookingdata.booking.mainData.customer}/>
            <input type='hidden' name='mobile_no' value={bookingdata.booking.mainData.customer_contact}/>
            <input type='hidden' name='email' value={bookingdata.booking.mainData.customer_email}/>
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 800, fontSize: '1.15rem', color: '#1A0F3B', mb: 2 }}>
              {t('payment', { defaultValue: 'Pago' })}
            </Typography>
              <FormControl fullWidth sx={{ mb: 2.5 }}>
              <FormLabel sx={{ fontFamily: C2_FONT, color: '#766293', mb: 1 }}>{t('payment')}</FormLabel>
              <Select
                  id="selectedProviderIndex"
                  name= "selectedProviderIndex"
                  value={selectedProviderIndex}
                  label={t('payment')}
                  onChange={handleChange}
                  sx={{
                    borderRadius: '12px',
                    fontFamily: C2_FONT,
                    textAlign: isRTL === 'rtl' ? 'right' : 'left',
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D7CFEB' },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6411ED' },
                  }}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {providers.map((provider,index) =>
                    <MenuItem key={provider.name} value={index}><img style={{height:24,margin:7}} src={icons[provider.name]} alt={provider.name}/> </MenuItem>
                  )}
                </Select>
              </FormControl>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button onClick={handlePaymentModalClose} variant="outlined" sx={c2SecondaryBtnSx}>
              {t('cancel')}
            </Button>
            <Button variant="contained" type="submit" sx={c2SuccessBtnSx} onClick={handlePaymentModalClose}>
              {t('paynow_button')}
            </Button>
            </Box>
          </form>
          :null}
        </Box>
      </Modal>
      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={estimatedata.error.flag} onClose={handleEstimateErrorClose}>{estimatedata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </Box>
  );
}
